import React, { useCallback } from "react";
import { ActionButton, DefaultButton } from "office-ui-fabric-react";

import PatientsSittings from "../care-app-crud-single/patients-sittings/Main";
import PatientsDocuments from "../care-app-crud-single/patients-documents/Main";

export const SittingsButton = ({ item, passConfig, btnProps, btnType }) => {
  const { setRenderInPanel, Config } = passConfig;
  const showPanel = useCallback(() => {
    const goBack = () => setRenderInPanel(null);
    const SittingsElement = (
      <PatientsSittings patient={item[Config.primaryKey]} goBack={goBack} />
    );
    setRenderInPanel(SittingsElement);
  }, [setRenderInPanel, Config.primaryKey, item]);

  return btnType === "default" ? (
    <DefaultButton
      iconProps={{ iconName: "People" }}
      text="View / Add"
      {...btnProps}
      onClick={showPanel}
    />
  ) : (
    <ActionButton
      iconProps={{ iconName: "People" }}
      text="View / Add"
      {...btnProps}
      onClick={showPanel}
    />
  );
};

export const DocumentsButton = ({ item, passConfig, btnProps, btnType }) => {
  const { setRenderInPanel, Config } = passConfig;
  const showPanel = useCallback(() => {
    const goBack = () => setRenderInPanel(null);
    const DocumentsElement = (
      <PatientsDocuments patient={item[Config.primaryKey]} goBack={goBack} />
    );
    setRenderInPanel(DocumentsElement);
  }, [setRenderInPanel, item, Config.primaryKey]);

  return btnType === "default" ? (
    <DefaultButton
      iconProps={{ iconName: "People" }}
      text="View / Add"
      {...btnProps}
      onClick={showPanel}
    />
  ) : (
    <ActionButton
      iconProps={{ iconName: "People" }}
      text="View / Add"
      {...btnProps}
      onClick={showPanel}
    />
  );
};
